var __values = (this && this.__values) || function(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
};
export var productsFallback = {
    "https://api.move.tomtom.com": [
        {
            id: "aa",
            displayName: "Area Analysis",
            redirectLink: "https://aa.tomtom.com/",
        },
        {
            id: "ja",
            displayName: "Junction Analytics",
            redirectLink: "https://ja.tomtom.com",
        },
        {
            id: "od",
            displayName: "O/D Analysis",
            redirectLink: "https://od.tomtom.com/dashboard",
        },
        {
            id: "rer",
            displayName: "Road Event Reporter",
            redirectLink: "https://rer.tomtom.com/",
        },
        {
            id: "ctm",
            displayName: "Route Monitoring",
            redirectLink: "https://rm.tomtom.com",
        },
        {
            id: "ts",
            displayName: "Traffic Stats",
            redirectLink: "https://ts.tomtom.com",
        },
        {
            id: "tv",
            displayName: "Traffic Viewer",
            redirectLink: "https://viewer.city.tomtom.com/",
        },
    ],
    "https://preprod.api.move.tomtom.com": [
        {
            id: "aa",
            displayName: "Area Analysis",
            redirectLink: "https://aa.tomtom.com/",
        },
        {
            id: "ja",
            displayName: "Junction Analytics",
            redirectLink: "https://test.ja.tomtom.com",
        },
        {
            id: "od",
            displayName: "O/D Analysis",
            redirectLink: "https://preprod.od.tomtom.com",
        },
        {
            id: "rer",
            displayName: "Road Event Reporter",
            redirectLink: "https://test.rer.tomtom.com",
        },
        {
            id: "ctm",
            displayName: "Route Monitoring",
            redirectLink: "http://brda-01.ttg.global:8098",
        },
        {
            id: "ts",
            displayName: "Traffic Stats",
            redirectLink: "https://preprod.ts.tomtom.com",
        },
        {
            id: "tv",
            displayName: "Traffic Viewer",
            redirectLink: "https://viewer.city.tomtom.com",
        },
    ],
    "https://test.api.move.tomtom.com": [
        {
            id: "aa",
            displayName: "Area Analysis",
            redirectLink: "https://aa.tomtom.com/",
        },
        {
            id: "ja",
            displayName: "Junction Analytics",
            redirectLink: "https://test.ja.tomtom.com",
        },
        {
            id: "od",
            displayName: "O/D Analysis",
            redirectLink: "https://preprod.od.tomtom.com",
        },
        {
            id: "rer",
            displayName: "Road Event Reporter",
            redirectLink: "https://test.rer.tomtom.com",
        },
        {
            id: "ctm",
            displayName: "Route Monitoring",
            redirectLink: "http://brda-01.ttg.global:8098",
        },
        {
            id: "ts",
            displayName: "Traffic Stats",
            redirectLink: "https://preprod.ts.tomtom.com",
        },
        {
            id: "tv",
            displayName: "Traffic Viewer",
            redirectLink: "https://viewer.city.tomtom.com",
        },
    ],
};
export function validateProductsFallback(apiUrl, actualProducts) {
    var e_1, _a;
    var errors = [];
    var envFallback = productsFallback[apiUrl];
    if (envFallback) {
        var _loop_1 = function (product) {
            var e_2, _b;
            var fallback = envFallback.find(function (p) { return product.id === p.id; });
            if (!fallback) {
                errors.push("Fallback for product \"".concat(product.id, "\" is not present."));
                return "continue";
            }
            try {
                for (var _c = (e_2 = void 0, __values(Object.keys(fallback))), _d = _c.next(); !_d.done; _d = _c.next()) {
                    var key = _d.value;
                    if (fallback[key] !== product[key]) {
                        errors.push("There is a difference in the value of \"".concat(key, "\" for product \"").concat(product.id, "\". Fallback: \"").concat(fallback[key], "\", API: \"").concat(product[key], "\"."));
                    }
                }
            }
            catch (e_2_1) { e_2 = { error: e_2_1 }; }
            finally {
                try {
                    if (_d && !_d.done && (_b = _c.return)) _b.call(_c);
                }
                finally { if (e_2) throw e_2.error; }
            }
        };
        try {
            for (var actualProducts_1 = __values(actualProducts), actualProducts_1_1 = actualProducts_1.next(); !actualProducts_1_1.done; actualProducts_1_1 = actualProducts_1.next()) {
                var product = actualProducts_1_1.value;
                _loop_1(product);
            }
        }
        catch (e_1_1) { e_1 = { error: e_1_1 }; }
        finally {
            try {
                if (actualProducts_1_1 && !actualProducts_1_1.done && (_a = actualProducts_1.return)) _a.call(actualProducts_1);
            }
            finally { if (e_1) throw e_1.error; }
        }
    }
    else {
        errors.push("Fallback for API \"".concat(apiUrl, "\" is not present."));
    }
    if (errors.length > 0) {
        console.error("Fallback values for products in API ".concat(apiUrl, " are out of date! ") +
            "Please update them in legoland-sdk in fallbackData.ts:\n\n" +
            errors.map(function (e) { return " * ".concat(e, "\n"); }).join(""));
    }
}
//# sourceMappingURL=fallbackData.js.map